import { APIClient } from "@/lib/api/client";

export default {
  oidc: {
    authority: "https://ssofirma.aguasandinas.cl/auth/realms/produccion",
    client_id: "proveedores-prod-front",
    scopes: "openid email profile roles",
  },
  logout_redirect_url: "https://firmadigital.aguasandinas.cl/",
  path: process.env.NODE_ENV === "production" ? "" : "",
  hostname: location.protocol + "//" + location.hostname + ":3000/api",
  client: new APIClient(
    location.protocol + "//" + location.hostname + ":3000/api"
  ),
};
